import { render } from "./accountFormImage.vue?vue&type=template&id=3047adbc&scoped=true"
import script from "./accountFormImage.vue?vue&type=script&lang=js"
export * from "./accountFormImage.vue?vue&type=script&lang=js"

import "./accountFormImage.vue?vue&type=style&index=0&id=3047adbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3047adbc"

export default script